const INITIAL_STATE = {
  all: [],
  current: null,
}

export default {
  namespaced: true,
  state: {
    ...INITIAL_STATE,
  },
  getters: {
    find: (state) => (id) => state.find(el => el.id === id),
  },
  mutations: {
    setCurrent: (state, { item }) => {
      state.current = item
    },
    add: (state, { item, prepend = false }) => {
      if (prepend) {
        state.all.unshift(item)
      } else {
        state.all.push(item)
      }
    },
    remove: (state, { id }) => {
      let idx = state.all.findIndex(el => el.id === id)
      state.all.splice(idx, 1)
    },
    
  },
  actions: {
    get: ({ dispatch, rootGetters, commit }, { id }) => {
      let headers = {
        'Content-Type': 'application/json',
      }
      Object.assign(headers, rootGetters['Api/getAuthHeader'])
      
      return dispatch('Api/apiRequest', {
        actionPath: ['/api/images/get/', id, '.json'].join(''),
        method: 'get',
        headers: headers,
        
      }, { root: true }).then(result => {
        
        // commit('addClient', result);
        
        return Promise.resolve(result)
      })
    },
  },
}
